import { clsx } from "clsx";
import { MouseEventHandler, ReactNode } from "react";

import Markdown from "@/components/common/Markdown";
import { useDebugLifecycle } from "@/utils/debug/useDebugLifecycle";

export const KeyV = ({
  name,
  value,
  icon,
  onClick,
  forceOnClick,
  className,
  useMarkdown = false,
}: {
  name: string;
  value?: string;
  icon?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  forceOnClick?: boolean;
  className?: string;
  useMarkdown?: boolean;
}) => {
  useDebugLifecycle("KeyV", {
    data: {
      url: window.location.href,
    },
  });

  // Normalize double-escaped newlines (\\n -> \n) for backwards compatibility with legacy data
  const normalizedValue = value?.replace(/\\n/g, "\n");

  const valueElement = useMarkdown ? (
    <div className="prose prose-neutral prose-img:m-0">
      <Markdown
        components={{
          p: ({ children }) => <p className="whitespace-pre-wrap">{children}</p>,
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              {children}
            </a>
          ),
        }}
      >
        {normalizedValue}
      </Markdown>
    </div>
  ) : (
    <span className="whitespace-pre-wrap">{normalizedValue}</span>
  );

  return (
    <div
      className={clsx(
        "bg-slate-100 flex flex-col py-2 px-4 rounded-md min-w-24",
        (onClick ?? forceOnClick) && "hover:bg-orange-100 cursor-pointer",
        className,
      )}
      onClick={onClick}
    >
      <span className="font-semibold break-all">
        {icon} {name}
      </span>
      {value && valueElement}
    </div>
  );
};
